
// let urlStr = 'http://192.168.2.107/gyh2020/public/index.php' //
// let urlStr = 'http://cshadmin.demo.csz.emof.cn/index.php' //
let urlStr = 'http://demo.csz.emof.cn/index.php' //
// let urlStr = 'http://192.168.2.165/' //
let localAnStore = [

  {
    key: 'user',
    type: 'localStorage'
  }, // 用户名
]
export default {
  urlStr,
  localAnStore,
}
